import { create } from "zustand";
import { TProjectDetailsSidebar } from "../pages/ProjectDetailsPage/model/types/types";
import {
  ArticleIcon,
  ChatCircleTextIcon,
  CheckCircleIcon,
  DatabaseIcon,
  Icon,
  SparkleIcon
} from "@phosphor-icons/react";

export type TSidebarOption = {
  value: TProjectDetailsSidebar;
  label: string;
  icon: Icon;
  title: string;
  isLabs: boolean;
};

export const sidebarOptions: TSidebarOption[] = [
  { value: "analysis", label: "AQ", icon: CheckCircleIcon, title: "Analysis Questions", isLabs: false },
  { value: "intelligence-questions", label: "IQ", icon: SparkleIcon, title: "Intelligence Questions", isLabs: false },
  { value: "claims", label: "Claims", icon: ArticleIcon, title: "Claims Extraction", isLabs: false },
  { value: "comments", label: "Comments", icon: ChatCircleTextIcon, title: "Comments", isLabs: false },
  { value: "vault", label: "Vault", icon: DatabaseIcon, title: "Document Vault", isLabs: false }
];

type TStore = {
  openSidebar: TProjectDetailsSidebar | null;
  openHandler: (name: TProjectDetailsSidebar | null) => void;
  isLabsTabOpen: () => boolean;
  closeHandler: () => void;
  toggleHandler: (name: TProjectDetailsSidebar | null) => void;
  scrollToBottomCallback: (() => void) | null;
  setScrollToBottomCallback: (callback: (() => void) | null) => void;
};

export const useProjectSidebarStore = create<TStore>((set, get) => ({
  openSidebar: null,
  scrollToBottomCallback: null,

  openHandler: (name) => set({ openSidebar: name }),
  isLabsTabOpen: () => sidebarOptions.find((option) => option.value === get().openSidebar)?.isLabs ?? false,
  closeHandler: () => set({ openSidebar: null }),
  toggleHandler: (name) => set((s) => ({ openSidebar: s.openSidebar === name ? null : name })),
  setScrollToBottomCallback: (callback: (() => void) | null) => set({ scrollToBottomCallback: callback })
}));
